import { render, staticRenderFns } from "./ChiefsEditComponent.vue?vue&type=template&id=01f66aca"
import script from "./ChiefsEditComponent.vue?vue&type=script&lang=js"
export * from "./ChiefsEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports